import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import * as moment from "moment";
@Component({
  selector: "app-calendar-form",
  templateUrl: "./calendar-form.component.html",
  styleUrls: ["./calendar-form.component.scss"]
})
export class CalendarFormComponent implements OnInit {
  @Output() onChange: EventEmitter<string[]> = new EventEmitter();
  @Input() action: "range" | "schedule" | "date" = "range";
  private format: string = "MM-dd-yy";
  pipe: DatePipe = new DatePipe("en_US");

  public set: Set<string> = new Set([]);
  constructor() {}

  public current: string = this.pipe.transform(new Date(), this.format);
  public dates: Date[] = [];

  ngOnInit(): void {
    this.dates = this.getDates();
  }

  next() {
    this.current = this.pipe.transform(
      moment(new Date(this.current).getTime()).add(1, "month"),
      this.format
    );
    this.dates = this.getDates();
  }

  previous() {
    this.current = this.pipe.transform(
      moment(new Date(this.current).getTime()).subtract(1, "month"),
      this.format
    );
    this.dates = this.getDates();
  }

  get month(): string {
    return this.current
      ? this.pipe.transform(new Date(Date.parse(this.current)), "MMM yy")
      : "";
  }

  getDates(): Date[] {
    let start = moment(this.getDate(this.current)).startOf("month");
    let day = start.weekday();
    let dates: Date[] = [];
    for (var i = 0; i < 35; i++) {
      let offset = day - i;
      let date: Date;
      if (i <= day)
        date = moment(start)
          .subtract(offset, "days")
          .toDate();
      else
        date = moment(start)
          .add(-1 * offset, "days")
          .toDate();
      dates.push(date);
    }
    return dates;
  }

  select(date: Date) {
    if (this.set.has(this.pipe.transform(date, this.format))) {
      this.set.delete(this.pipe.transform(date, this.format));
    } else {
      this.set.add(this.pipe.transform(date, this.format));
    }
    this.onChange.emit(Array.from(this.set.values()));
  }

  getDate(s: string) {
    //? In the form of this.format
    return new Date(Date.parse(s));
  }

  public defaultEnd: string = this.pipe.transform(
    moment().add(3, "months"),
    this.format
  );
  public end: string = this.defaultEnd;

  selectWeekday(weekday: number) {
    var arg = Array.from(this.set.values());
    if (this.isWeekdayActive(weekday)) {
      for (var i = 0; i < arg.length; i++) {
        if (this.getDate(arg[i]).getDay() == weekday) {
          this.set.delete(arg[i]);
        }
      }
    } else {
      for (
        var d = this.dates[weekday];
        d.getTime() < this.getDate(this.end).getTime();
        d = moment(d)
          .add(1, "week")
          .toDate()
      ) {
        this.set.add(this.pipe.transform(d, this.format));
      }
    }

    this.onChange.emit(Array.from(this.set.values()));
  }

  isWeekdayActive(weekday: number): boolean {
    var dates = this.dates.filter(a => a.getDay() == weekday);
    return dates.every(a => this.set.has(this.pipe.transform(a, this.format)));
  }

  submit() {}

  isThisMonth(date: Date): boolean {
    return this.getDate(this.current).getMonth() != new Date(date).getMonth();
  }

  isSelected(date: Date): boolean {
    return this.set.has(this.pipe.transform(date, this.format));
  }
}
